import { DataItem, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Col, Row } from 'antd'
import { titleCase } from '../../../utils/general'

const DETAIL_KEYS = ['order', 'delivery']

type DeliveryReportDetailsProps = {
  details: Record<string, string[]>
  detailKeys: string[]
}

export function DeliveryReportDetails({ details, detailKeys }: DeliveryReportDetailsProps) {
  return (
    <div className='details-container'>
      <Row justify='space-between'>
        {detailKeys
          ?.filter((d) => DETAIL_KEYS.includes(d))
          .map((key) => (
            <Col key={key} span={12}>
              <DataItem label={titleCase(key)}>
                <Vertical>
                  {details[key].map((d) => (
                    <Texto key={key}>{d}</Texto>
                  ))}
                </Vertical>
              </DataItem>
            </Col>
          ))}
      </Row>
    </div>
  )
}
